import { useState } from "react"
import { HomeIcons, NotificationIcons, TcIcons, MyToolIcons, ReferUserIcons, RenewIcons } from '../../global/Icons';
import { ApproverIcon, HelpIcon, Inquiries, LibraryIcon, ReportIcon, SupportIcon } from "../../global/icon/icon";

export const NavigationStates = () => {
    
    const [tabs, setTabs] = useState({
        top: [
            {name:'Notifications', steps:'ninth-step', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#333333" />, active: <NotificationIcons fill="#107038" />},
            {name:'MyTools', steps:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#292D32" />, active:<MyToolIcons fill="#107038" stroke="#107038"/>},
        ],
        mtop: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#fff" />, active: <NotificationIcons fill="#fff" />},
            {name:'MyTools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#FFFFFF" stroke="#FFFFFF" />, active:<MyToolIcons fill="#107038" stroke="#107038"/>},
        ],
        left: [
            {name:'Library', steps:'first-step', subdir:'/biz/library?sub=publication&tag=all', ref: 'library', not_active:<LibraryIcon width="20px" height="20px" type="default"/>, active:<LibraryIcon width="20px" height="20px" type="active"/>},
            {name:'Approver', steps:'second-step', subdir:'/biz/approver?sub=publication&tag=all', ref: 'approver', not_active:<ApproverIcon width="20px" height="20px" type="default" />, active:<ApproverIcon width="20px" height="20px" type="active" />},
            {name:'Report', steps:'third-step', subdir:'/biz/report?sub=publication&tab=article', ref: 'report', not_active:<ReportIcon width="20px" height="20px" type="default"/>, active:<ReportIcon width="20px" height="20px" type="active"/>},
            {name:'Inquiries', steps:'fourth-step', subdir:'/biz/inquiries', ref: 'inquiries', not_active:<Inquiries width="20px" height="20px" type="default"/>, active:<Inquiries width="20px" height="20px" type="active"/>},
        ],
        bottomLeft: [
            {name:'Help', steps:'fifth-step', subdir:'/psl/help', ref: 'help', not_active:<HelpIcon type="default" height="20px" width="20px"/>, active:<HelpIcon type="active" height="20px" width="20px" fill="#003F2E"/>},
            {name:'Support', steps:'sixth-step', subdir:'', ref: 'support', not_active:<SupportIcon width="20px" height="20px" type="default"/>, active:<SupportIcon width="20px" height="20px" type="active" fill="#003F2E"/>},
        ],
        msetting: [
            {name:'Refer a Hero Users', subdir:'/biz', ref: 'biz', steps: 'sixth-step', not_active:<ReferUserIcons fill="#fff" stroke="#A2A3A9"/>, active:<ReferUserIcons fill="#333333" stroke="#333333"/>},
            {name:'System Updates', subdir:'/biz', ref: 'biz', steps: 'seventh-step', not_active:<RenewIcons fill="none" stroke="#89A594"/>, active:<RenewIcons fill="#333333" stroke="#333333"/>},
        ],
        mobile: [
            {name:'Dashboard', sub_name:'', subdir:'/biz', ref: undefined, steps:'first-step', not_active:<HomeIcons stroke="#89A594" />, active:<HomeIcons fill="#11783C" stroke="#FFFFFF"/>},
            {name:'Feature 1', sub_name:'', subdir:'/biz/feature1', ref: 'feature1', steps:'second-step', not_active:<HomeIcons stroke="#687B75"/>, active:<HomeIcons fill="#11783C" stroke="#fff"/>},
            {name:'Feature 2', sub_name:'', steps:'third-step', subdir:'/biz/feature2', ref: 'feature2',not_active:<HomeIcons stroke="#687B75"/>, active:<HomeIcons fill="#11783C" stroke="#fff"/>},
            {name:'Tool Categories', sub_name:'', steps:'fourth-step', subdir:'/biz/tool-categories/subscribed', ref: 'tool-categories', not_active:<TcIcons stroke={'#89A594'}  fill={'#fff'} />, active:<TcIcons fill="#107038" stroke="#107038"/>},
        ]
    })
    const [tc, setTc] = useState({open: true, list: false})
    const [leftBar, setLeftbar] = useState(true)
    const [notif,  setNotif] = useState(false)
    const [myTool, setMyTool] = useState(false)
    const [myToolPzl, setMyToolPzl] = useState(false)
    const [help, setHelp] = useState({
        toggled: false,
        feature_list: [
            {
                name: 'Tour me',
                ref: 'tour-me',
                toggled: false,
                type: 'dropdown',
                sub_feature_list: [
                    {name: 'General', ref: 'general'},
                    {name: 'Library', ref: 'library'},
                    {name: 'Approver', ref: 'approver'},
                    {name: 'Report', ref: 'report'},
                    {name: 'Inquiry', ref: 'inquiry'}
                ]
            },
            {
                name: `FAQ's`,
                ref: 'faq',
                toggled: false,
                type: 'link',
                sub_feature_list: []
            }
        ]
    })

    return {
        tabs: {data: tabs, set: setTabs},
        tc: {data: tc, set: setTc},
        leftBar: {data: leftBar, set: setLeftbar},
        notif: {data: notif, set: setNotif},
        myTool: {data: myTool, set: setMyTool},
        myToolPzl: {data: myToolPzl, set: setMyToolPzl},
        help: {data: help, set: setHelp},
    }
}